import styled from 'styled-components'

import { SliderButton as SliderButtonBig } from '../Following/styled'

export const SliderButton = styled(SliderButtonBig)`
  width: 26px;
  height: 26px;
`
